import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const candidaturas = {
	state: {
		
	},
	getters: {
   
	},
	actions: {
		requestCandidaturas:({commit,getters},usertype) =>{

			return new Promise((resolve, reject) => {
				console.log(usertype)
				axios.get('/ws/getCandidaturas'+usertype).then( result => {
					console.log(result)
                    if(result.data.status == 0){
						resolve(result.data.candidaturas);
					}else{
						commit('setError',result.data.status);
						dispatch('sendInfoAboutError',result.data);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},
		requestDocumentacion:({commit,getters},usertype) =>{

			return new Promise((resolve, reject) => {
				axios.get('/ws/getDocumentacion').then( result => {
                    if(result.data.status == 0){
						resolve(result.data.Anexos);
					}else{
						commit('setError',result.data.status);
						dispatch('sendInfoAboutError',result.data);
					}
				}).catch(error => {
					reject(false);
				});  				
			});	
		},

	},
	mutations: {
     
	}
}

export default candidaturas;


// WEBPACK FOOTER //
// ./src/store/candidaturasmodule.js